export const FETCH_HOSPITAL_AFFILIATIONS_START = 'FETCH_HOSPITAL_AFFILIATIONS_START';
export const FETCH_HOSPITAL_AFFILIATIONS_SUCCESS = 'FETCH_HOSPITAL_AFFILIATIONS_SUCCESS';
export const FETCH_HOSPITAL_AFFILIATIONS_FAILURE = 'FETCH_HOSPITAL_AFFILIATIONS_FAILURE';

export const FETCH_HOSPITAL_AFFILIATION_START = 'FETCH_HOSPITAL_AFFILIATION_START';
export const FETCH_HOSPITAL_AFFILIATION_SUCCESS = 'FETCH_HOSPITAL_AFFILIATION_SUCCESS';
export const FETCH_HOSPITAL_AFFILIATION_FAILURE = 'FETCH_HOSPITAL_AFFILIATION_FAILURE';

export const SET_HOSPITAL_AFFILIATIONS_QUERY_PARAMS = 'SET_HOSPITAL_AFFILIATIONS_QUERY_PARAMS';
